import AdminVisitsList from '@/visits/visit/views/admin/list/AdminVisitList';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/requests/viewVisit/listRequestAdmin',
)({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' });
    }


    const { isAdmin, isRRHH, } = context.userRoles;
    if (!isAdmin && !isRRHH) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="container mx-auto">
      <AdminVisitsList />
    </div>
  )
}